/**
  二级导航栏
 */
<template>
  <div>
    <hom-header></hom-header>
    <div class="secondNav">
      <div class="top-page-nav">
        <div class="product-menu" @mouseover="showMenu=true" @mouseleave="showMenu=false">
          <div class="product-title">
            全部商品分类 <icon-svg icon-class="list"></icon-svg>
          </div>
          <div class="menu-list" v-show="showMenu || home">
            <div class="menu-box">
              <div class="container">
                <div class="menu">
                  <div v-for="(c, index) in categoryList" :key="index">
                    <div class="li" @click="goCategory(c)">{{c.classifyName}}</div>
                    <div class="li sub" v-if="c.childs.length > 0">
                      <span v-for="(child, i) in c.childs" v-if="i < 2" :key="i" @click="goCategory(child)">{{child.classifyName}}</span>
                    </div>
                    <div class="li sub" v-if="c.childs.length > 2">
                      <span v-for="(child, i) in c.childs" v-if="i >= 2 && i < 4" :key="i" @click="goCategory(child)">{{child.classifyName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ul class="nav-tab-container" style="display: none">
          <li class="nav-tab">
            <a rel="noopener" target="_blank" href="#" class="link">
              2-1
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="loginP" v-if="home">
      <div class="loginDiv">
        <div class="top">
          <div v-if="isLogin" @click="goToUserInfo" style="cursor: pointer">
            <el-avatar :size="70" :src="avatar" ></el-avatar>
          </div>
          <el-avatar :size="70" :src="avatar" v-if="!isLogin"></el-avatar>
          <div class="hi">
            <div>hi，{{userInfo.name || '您好'}}！</div>
            <div>欢迎来到幼教网</div>
          </div>
          <div class="botton" v-if="!isLogin">
            <el-button @click="register" round>注册</el-button>
            <el-button @click="loginBtn" round>登录</el-button>
          </div>
          <div class="botton" v-if="isLogin">
            <el-button @click="goToUserInfo" round>我的</el-button>
            <el-button @click="outLogin" round>退出</el-button>
          </div>
        </div>
        <div class="bottom">
          <div class="aLink" @click="goToOrder">
            <div>
              <i class="el-icon-s-order" style="color: #febe26"></i>未确认订单
            </div>
          </div>
          <div class="aLink" @click="goToOrder2">
            <div><i class="el-icon-s-claim" style="color: #0cca8a"></i>已确认订单</div>
          </div>
          <div class="aLink" @click="goToShopCart">
            <div><i class="el-icon-shopping-cart-2" style="color: #7b7afa"></i>我的购物车</div>
          </div>
          <div class="aLink" @click="goToMessage">
            <div><i class="el-icon-chat-line-square" style="color: #ff7e71"></i>消息中心</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cookie from "js-cookie";
  import { mapGetters, mapMutations } from "vuex";
  import {
    getCategory
  } from '@/api/nav.js'
  import HomHeader from '@/components/base/homHeader'
export default {
  components: {HomHeader},
  props: {
    home: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMenu: false,
      categoryList: [],
      isLogin: false,
      avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
    }
  },
  watch: {
    '$store.state.userInfo': {
      handler (nVal, oVal) {
        if(this.isLogin){
          this.avatar = this.userInfo.headImage
        }
      }
    }
  },
  mounted() {
    if (!Cookie.get("token")) {
      this.isLogin = false
    }else{
      this.isLogin = true
    }
    this.getCategory()
  },
  computed: {
    ...mapGetters(["userInfo", 'cartNumber']),
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ',
      setUserInfo: 'SET_USERINFO',
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART',
      setNewAddress: 'SET_NEWADDRESS',
      setAreaCode: 'SET_AREACODE',
      setNoticeId: 'SET_NOTICEID',
      IS_LOGIN: 'IS_LOGIN'
    }),
    async getCategory(){
      const response = await getCategory({
        second: true
      });
      const res = response.data
      if (res.code === "200") {
        this.categoryList = res.data
        console.info(this.categoryList)
      }else{
        this.$message({
          message: res.message,
          type: "error",
        })
      }
    },
    goCategory(item){
      let routeUrl = this.$router.resolve({
        name: 'category',
        query: {classifyData: JSON.stringify(item)}
      })
      window.open(routeUrl.href, '_blank');
    },
    register(){
      this.$router.push({
        path: '/register'
      })
    },
    loginBtn () {
      this.$router.push({path: '/login'})
    },
    goToUserInfo () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/userInfo'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/userInfo')})
      }
    },
    goToMessage () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/message'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/message')})
      }
    },
    goToOrder () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/myOrder'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/myOrder')})
      }
    },
    goToOrder2 () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/myOrder2'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/myOrder2')})
      }
    },
    goToUserAddress () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/signingAddress'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/signingAddress')})
      }
    },
    goToShopCart () {
      if (Cookie.get('token')) {
        this.$router.push({path: '/shopping-trolley'})
      } else {
        this.$router.push({path: '/login?rtn=' + encodeURIComponent('/shopping-trolley')})
      }
    },
    outLogin () {
      Cookie.remove('token')
      this.isLogin = false
      this.avatar = "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      this.setUserInfo({})
      this.setCartNumber('')
      this.setShoppingCart({})
      this.setNewAddress({})
      this.setAreaCode([])
      this.$store.commit('IS_LOGIN', false) // 清除登录状态
    }
  }
}
</script>

<style lang="scss" scoped>
.secondNav{
  position: relative;
  margin-top: 20px;
  background: #fff;
  border-bottom: 2px solid $mainColor;
  z-index: 20;
  height: 48px;
  .top-page-nav{
    width: 1200px;
    margin: 0 auto;
    height: 40px;
    background-color: #fff;
    padding-top: 8px;
    zoom: 1;
    position: relative;
    z-index: 9;
    .product-menu{
      position: absolute;
      left: 0;
      width: 227px;
      .product-title {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        color: #fff;
        padding: 12px 30px;
        background-color: $mainColor;
        line-height: 16px;
        font-weight: 700;
        cursor: pointer;

        >>>.svg-icon{
          position: absolute;
          right: 20px;
          top: 14px;
          font-size: 16px;
        }
      }
      .menu-list{
        position: absolute;
        top: 40px;
        .menu-box {
          box-shadow: 0 2px 12px 0 rgba(0,0,0,8%);
          border: 1px solid $mainColor;
          font-size: 15px;
          background-color: #fff;
          border-bottom-right-radius: 4px;
          border-bottom-left-radius: 4px;
          width: 227px;
          height: 450px;
          overflow: hidden;
          .container {
            position: relative;
            z-index: 9;
            width: 1200px;
            .menu {
              float: left;
              width: 227px;
              padding-top: 8px;
              .li{
                height: 40px;
                padding-left: 16px;
                font-size: 18px;
                line-height: 40px;
                font-weight: 700;
                color: #000;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                cursor: pointer;
                &:hover{
                  background-color: rgba(0, 64, 151, 0.1);
                  color: $mainColor;
                }
              }
              .sub{
                height: 30px;
                font-size: 16px;
                line-height: 30px;
                font-weight: 400;
                color: #999;
                &:hover{
                  background-color: transparent;
                  color: #999;
                }
                span{
                  width: 45%;
                  display: inline-block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  &:first-child{
                    margin-right: 8%;
                  }
                  &:hover{
                    color: $mainColor;
                  }
                }
              }
            }
          }
        }
      }
    }

    .nav-tab-container{
      position: absolute;
      left: 237px;
      color: #333;
      padding: 12px 0;
      font-size: 16px;
      line-height: 16px;
      font-weight: 700;
      .nav-tab {
        display: inline-block;
        margin-left: 40px;
        .link {
          color: inherit;
          &:hover{
            color: $mainColor;
          }
        }
      }
    }
  }
}

.loginP{
  position: relative;
  width: 1200px;
  margin: 0 auto;
  .loginDiv{
    position: absolute;
    top: 120px;
    right: 50px;
    z-index: 99;
    width: 220px;
    .top{
      height: 177px;
      background-color: #0053c9;
      position: relative;

      >>>.el-avatar{
        position: absolute;
        top: -35px;
        left: calc(50% - 35px);
      }
      .hi{
        color: #fff;
        text-align: center;
        padding-top: 50px;
        line-height: 25px;
      }
      .botton{
        margin-top: 20px;
        text-align: center;

        >>>.el-button{
          background-color: transparent;
          color: #FFF;
          border: 2px solid #fff;
          padding: 10px 23px;
          &:hover{
            background-color: #000;
          }
        }
      }
    }
    .bottom{
      height: 164px;
      background-color: #fff;
      .aLink{
        width: 50%;
        text-align: center;
        padding: 15px 0 10px;
        float: left;
        cursor: pointer;
        font-size: 14px;
        i{
          font-size: 30px;
          display: block;
          padding-bottom: 5px;
        }
        &:hover{
          color: $mainColor;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/base/secondNav.vue